import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useProspectAuth } from '../Auth/ProspectAuthContext';

const PrivateRoute = ({ adminOnly = false }) => {
  const { user, loading } = useProspectAuth();
  if (loading) return null;
  if (!user) return <Navigate to='/login' replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to='/dashboard' replace />;
  return <Outlet />;
};

export default PrivateRoute;
